module.exports = __webpack_public_path__ + "img/violet_093.d26ffe60.png";